import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-649b1450"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-display" }
const _hoisted_2 = {
  class: "app-display__item app-display__title",
  test: "display-item title"
}
const _hoisted_3 = { class: "app-display__status app-display__status--error" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "app-display__status app-display__status--success" }, "OK", -1))
const _hoisted_5 = {
  class: "app-display__item app-display__feedback",
  test: "display-item feedback"
}

import PinRow from '@/components/structure/PinRow.vue';
import BaseDigit from '@/components/base/BaseDigit.vue';

import { useStore } from 'vuex';
import useLock from '@/behaviours/useLock';
import { computed } from 'vue';

export type Props = {
  code: string,
  validLength: number,
  visibleFromLast?: number,
  isPinLocked?: boolean,
  isValidating?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDisplay',
  props: {
    code: null,
    validLength: null,
    visibleFromLast: { default: JSON.parse(process.env.VUE_APP_PIN_SHOW_LAST) },
    isPinLocked: { type: Boolean, default: false },
    isValidating: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { code: string, validLength: number, visibleFromLast: number, isPinLocked: boolean, isValidating: boolean };



const store = useStore();  
const { paddedCountdown } = useLock();

const isLastAttempt = computed(() => store.getters.isLastAttempt);
const isFail = computed(() => store.getters.isFail);
const isSuccess = computed(() => store.getters.isSuccess);

function isCharVisible(charPos: number) {
  return charPos >= props.code.length - (props.visibleFromLast || 0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      (_unref(isFail))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("strong", _hoisted_3, _toDisplayString(__props.isPinLocked ? 'LOCKED' : 'ERROR'), 1),
            _createTextVNode(" " + _toDisplayString(__props.isPinLocked ? 'Keypad disabled' : 'Wrong PIN'), 1)
          ], 64))
        : (_unref(isSuccess))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_4,
              _createTextVNode(" PIN verified ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(" Enter your PIN code ")
            ], 64))
    ]),
    _createElementVNode("p", _hoisted_5, [
      (__props.isValidating)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Checking... ")
          ], 64))
        : (_unref(isFail) && !__props.isPinLocked)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_unref(isLastAttempt) ? 'Last try remaining' : 'Please try again'), 1)
            ], 64))
          : (_unref(isFail) && __props.isPinLocked)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(" Please wait " + _toDisplayString(_unref(paddedCountdown)) + " seconds ", 1)
              ], 64))
            : (_unref(isSuccess))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(" Your PIN is valid ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createTextVNode(" The code must be " + _toDisplayString(__props.validLength) + " characters long ", 1)
                ], 64))
    ]),
    _createVNode(PinRow, {
      class: _normalizeClass(["app-display__item app-display__pin", {
        'app-display__pin--error': _unref(isFail) && !__props.isValidating,
        'app-display__pin--loading': __props.isValidating || __props.isPinLocked
      }]),
      test: "display-item pin",
      "pin-length": __props.validLength,
      value: __props.code
    }, {
      default: _withCtx((slotProps) => [
        _createVNode(BaseDigit, {
          "is-visible": isCharVisible(slotProps.pinPos),
          value: slotProps.pinDigit
        }, null, 8, ["is-visible", "value"])
      ]),
      _: 1
    }, 8, ["class", "pin-length", "value"])
  ]))
}
}

})